import { Injectable, EventEmitter, Inject, isDevMode } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BaseRepository } from './base.repository';
import { IDriver } from '../interfaces/IDriver';
;

@Injectable()
export class DriverRepository extends BaseRepository {

    constructor(tokenHttp: TokenHttp) { 
        super(tokenHttp);
    }

    public getById(carrierId: number, id: number): Observable<IDriver> {
        return this.mapGet("carriers/" + carrierId + "/drivers/" + id);
    }

    public create(carrierId: number, driver: IDriver): Observable<IDriver> {
        return this.mapPost("carriers/" + carrierId + "/drivers/", driver);
    }

    public update(carrierId: number, driver: IDriver): Observable<IDriver> {
        return this.mapPut("carriers/" + carrierId + "/drivers/" + driver.id, driver);
    }

}